import { titleCaseFromCaps } from '@lbcamden/shared-utils';

import { PcfraPerson, PcfraStatus } from '~/common/types/people';
import { TableRow, UserStoreTables } from '~/common/types/tinybase';

export const getPersonTitleAndSurname = (person?: PcfraPerson) =>
  person ? titleCaseFromCaps(`${person?.title} ${person?.surname}`) : '';

export const buildExistingDraftsMap = (
  people: PcfraPerson[],
  pcfraDrafts: TableRow<UserStoreTables, 'pcfraDrafts'>[],
): Record<number, TableRow<UserStoreTables, 'pcfraDrafts'>> =>
  pcfraDrafts.reduce((map, draft) => {
    const person = people.find(({ personId }) => personId === draft.personId);
    const canEditDraft =
      person &&
      [PcfraStatus.Necessary, PcfraStatus.Drafting, PcfraStatus.Submitted].includes(
        person.pcfraStatus,
      );

    return canEditDraft ? { ...map, [draft.personId]: draft } : map;
  }, {});
